import { MatchedCurator } from 'src/Redux/matchedCuratorsApi'

export const MATCHED_CURATORS_PAGE_SIZE = 20

const BUDGET_THRESHOLD = 150
const MIN_CURATORS_FACTOR_LOW_BUDGET = 0.5
const MIN_CURATORS_FACTOR_HIGH_BUDGET = 0.4
const MAX_CURATORS_FACTOR = 0.7

export const getCuratorSubmissionsEstimation = (
  budget: number,
  minCuratorsCount: number | null,
  maxCuratorsCount: number | null,
): { min: number; max: number } => {
  const minCount = minCuratorsCount ?? 0
  const maxCount = maxCuratorsCount ?? 0

  if (budget < BUDGET_THRESHOLD) {
    return {
      min: Math.floor(minCount * MIN_CURATORS_FACTOR_LOW_BUDGET),
      max: Math.floor(maxCount * MAX_CURATORS_FACTOR),
    }
  }
  return {
    min: Math.floor(minCount * MIN_CURATORS_FACTOR_HIGH_BUDGET),
    max: Math.floor(maxCount * MAX_CURATORS_FACTOR),
  }
}

interface MatchedCuratorsBudget {
  data: Pick<MatchedCurator, 'retailPrice'>[]
  total: number
}

export const getAreMatchedCuratorsBelowMinBudget = (
  curatorsList: MatchedCuratorsBudget | undefined,
  minBudget: number | undefined,
): boolean => {
  if (!curatorsList || typeof minBudget !== 'number') {
    return false
  }
  if (curatorsList.data.length !== curatorsList.total) {
    return false
  }
  const matchedBudget = curatorsList.data.reduce(
    (sum, curator) => sum + curator.retailPrice,
    0,
  )
  return matchedBudget < minBudget
}
